export const isMobileDevice = () =>
	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
	isIPadDevice()
export const isIPadDevice = () => /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document
